import React from 'react';
import {HealthParameterType} from '../../common/config';
import HealthComponent from '../health-component/health-component';

export default function HeartRate() {
  return <HealthComponent type={HealthParameterType.HEART_RATE} />;
}
